// views/AuthCallback.js
// Propósito: Manejar callback de OAuth (Google), guardar token y restaurar sesión.

import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext.js';

function AuthCallback() {
  const { loginWithGoogle } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      (async () => {
        try {
          await loginWithGoogle(token);
          window.history.replaceState({}, '', '/');
        } catch {
          // noop: show minimal error UI
        }
      })();
    }
  }, [loginWithGoogle]);

  return (
    <div className="container py-4 app-shell">
      <div className="glass-card p-3">
        <h5>Procesando autenticación…</h5>
        <p className="text-muted">Serás redirigido automáticamente.</p>
      </div>
    </div>
  );
}

export default AuthCallback;
